var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4c0 1.103-.897 2-2 2H8.75v2h1.44c.67 0 1.004.81.532 1.281l-2.19 2.188a.747.747 0 0 1-1.06 0L5.282 9.28A.751.751 0 0 1 5.811 8H7.25V6H2C.897 6 0 5.103 0 4V2C0 .897.897 0 2 0h12c1.103 0 2 .897 2 2v2zm-2 8v-2h-2.584l.012-.013A1.73 1.73 0 0 0 11.772 8H14c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2.228a1.73 1.73 0 0 0 .344 1.987l.012.013H2v2h4.584l.179.178c.684.684 1.79.684 2.474 0L9.416 12H14z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.d1bbbee20b847fd8c149903d092add00.svg";
export { ForwardRef as ReactComponent };